import { useApi } from "@/hooks";
import { resolveReplayTeamColors } from "@Components/game/session-results/feedback/visualization/constants";
import type { KitStyles } from "@Components/game/session-results/feedback/visualization/team-colors";
import useGlobalContext from "@hooks/common/general/use-global-context";
import { Api } from "@Shared/schemas";
import { useEffect, useMemo } from "react";

const useReplayTeamColors = (styles?: KitStyles) => {
  const { globalState } = useGlobalContext();
  const { call: getUserTeamConfigs, data: userTeamConfigs } = useApi<typeof Api.Teams.GetTeamConfigs>({
    api: Api.Teams.GetTeamConfigs,
    disableLoader: true,
    request: {},
  });
  const { call: getAccountTeamConfigs, data: accountTeamConfigs } = useApi<typeof Api.Teams.GetTeamConfigs>({
    api: Api.Teams.GetTeamConfigs,
    disableLoader: true,
    request: {},
  });

  useEffect(() => {
    if (!globalState.user.id) {
      return;
    }

    getUserTeamConfigs({
      user_doc_id: globalState.user.id,
      limit: 1,
    });

    if (!globalState.account.id) {
      return;
    }

    getAccountTeamConfigs({
      account_id: globalState.account.id,
      user_doc_id: globalState.user.id,
      limit: 1,
    });
  }, [getAccountTeamConfigs, getUserTeamConfigs, globalState.account.id, globalState.user.id]);

  const fallbackHomeKit = (globalState.user as any)?.kit;
  const homeKit = userTeamConfigs?.[0]?.home_kit || accountTeamConfigs?.[0]?.home_kit || fallbackHomeKit;
  const isTeamColorsReady = Boolean(homeKit || (styles?.team_a?.colors?.primary && styles?.team_b?.colors?.primary));
  const teamColors = useMemo(() => resolveReplayTeamColors(homeKit, styles), [homeKit, styles]);

  return {
    teamColors,
    isTeamColorsReady,
  };
};

export default useReplayTeamColors;
